import {VuexSettingsRestClient} from "./lib/rest.js";

/**
 *
 * @package citrus.vuex.settings
 */
const settings = {
	namespaced: true,
	state: {
		available: false,
		viewGrid: '',
		pageCount: 16,
		sort: {
			order: 'name',
			by: 'asc'
		}
	},
	actions: {
		remove(store, code) {
			if(false === store.dispatch('check', code)) {
				return false;
			}

			store.commit('removeOption', code);
		},
		add(store, option) {
			if(false === store.getters.check(option.id)) {
				return false;
			}

			store.commit('addOption', option);
		},
		check(store, code) {
			return store.getters.check(code);
		},
		load(store, options) {
			if(undefined != options) {
				store.commit('loadOptions', options);
				return;
			}

			let restClient = new VuexSettingsRestClient();
			restClient.load().then((result) => {
				store.commit('loadOptions', result);
			});
		},
		setViewGrid(store, value) {
			let restClient = new VuexSettingsRestClient();
			restClient.setView(value).then((result) => {
				store.commit('viewGrid', result);
			});
		},
		setSortGrid(store, value) {
			let restClient = new VuexSettingsRestClient();
			restClient.setSort(value).then((result) => {
				store.commit('sortGrid', result);
			});
		},
		setPageCount(store, value) {
			let restClient = new VuexSettingsRestClient();
			restClient.setPageCount(value).then((result) => {
				store.commit('pageCount', result);
			});
		},
		setAvailable(store, value) {
			let restClient = new VuexSettingsRestClient();
			restClient.setAvailable(value).then((result) => {
				store.commit('available', result);
			});
		}
	},
	mutations: {
		loadOptions(state, options) {
			state.viewGrid = options.viewGrid;
			state.sort = options.sort;
			state.pageCount = options.pageCount;
			state.available = options.available;
		},
		removeOption(state, code) {
			delete state[code];
		},
		addOption(state, option) {
			state[option.id] = option.value;
		},
		viewGrid(state, value) {
			state.viewGrid = value;
		},
		pageCount(state, value) {
			state.pageCount = value;
		},
		sortGrid(state, value) {
			state.sort = value;
		},
		available(state, value) {
			state.available = value;
		}
	},
	getters: {
		check: state => code => {
			return ('undefined' !== state[code]);
		},
		viewGrid: state => {
			return state.viewGrid;
		},
		sortGrid: state => {
			return state.sort;
		},
		pageCount: state => {
			return state.pageCount;
		},
		available: state => {
			return state.available;
		}
	}
};

export {settings};
